import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'index',
    redirect: 'query',
    component: () => import('../views'),
    children: [
      {
        path: '/warning',
        redirect: 'country',
        name: 'warning',
        component: () => import('../views/warning'),//预警
        children: [
          {
            path: '/country',
            name: 'country',
            component: () => import('../views/warning/country')
          },
          {
            path: '/peril',
            name: 'peril',
            component: () => import('../views/warning/peril')
          },
          {
            path: '/typhoon',
            name: 'typhoon',
            component: () => import('../views/warning/typhoon')
          }
        ]
      },
      {
        path: '/query',
        name: 'query',
        redirect: 'ProduceReport',
        component: () => import('../views/query'),//查询
        children: [
          {
            path: '/ProduceReport',
            name: 'ProduceReport',
            component: () => import('../views/report/ProduceReport')
          },
          {
            path: '/Agriculture',
            name: 'Agriculture',
            component: () => import('../views/query/Agriculture')
          },
          {
            path: '/RiskZoning',
            name: 'RiskZoning',
            component: () => import('../views/query/RiskZoning')
          }
        ] 
      },
      {
        path: '/report',
        name: 'report',
        redirect: 'history',
        component: () => import('../views/report'),//报告
        children:[
          {
            path: '/history',
            name: 'history',
            component: () => import('../views/query/history')
          },
          {
            path: '/record',
            name: 'record',
            component: () => import('../views/report/record')
          },
          {
            path: '/push',
            name: 'push',
            component: () => import('../views/report/push')//推送 
          },
          {
            path: '/Insurance',
            name: 'Insurance',
            component: () => import('../views/report/Insurance')//保险 
          },
          {
            path: '/trigger',
            name: 'trigger',
            component: () => import('../views/report/Trigger')//触发点
          }
        ]
      },
      {
        path: '/service',
        name: 'service',
        redirect: 'WeatherService',
        component: () => import('../views/service'),//服务
        children:[
          {
            path: '/WeatherService',
            name: 'WeatherService',
            component: () => import('../views/service/WeatherService')
          },
        ]     
      },
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login')
  }
]

const router = createRouter({
  mode: 'hash',
  history: createWebHashHistory(),
  routes
})

export default router
